function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from "react";
import { Menu, Button, Space } from "antd";
import { ShieldLockFill, Speedometer, CupFill } from "react-bootstrap-icons";
import { Container, Row, Col } from "react-bootstrap";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SubMenu = Menu.SubMenu;

var DefaultNav = function DefaultNav(_ref) {
  var handleConnectButton = _ref.handleConnectButton;

  var _useState = useState('home'),
      _useState2 = _slicedToArray(_useState, 2),
      current = _useState2[0],
      setCurrent = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      drawerVisible = _useState4[0],
      setDrawerVisible = _useState4[1];

  var hideDrawer = function hideDrawer() {
    setDrawerVisible(false);
  };

  var handleClick = function handleClick(e) {
    setDrawerVisible(true);
  };

  return /*#__PURE__*/_jsx("div", {
    className: "nav-wrapper",
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: {
            span: 5
          },
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              padding: '8px',
              color: 'grey'
            },
            children: [/*#__PURE__*/_jsx("b", {
              children: "Plateforme"
            }), " de gestion de clinique"]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: {
            span: 2,
            offset: 1
          },
          md: {
            span: 2,
            offset: 1
          },
          sm: 4,
          xs: 4,
          className: "ant-menu-horizontal",
          children: /*#__PURE__*/_jsxs(Space, {
            align: "end",
            direction: "horizontal",
            children: [/*#__PURE__*/_jsx(ShieldLockFill, {
              size: 22
            }), /*#__PURE__*/_jsx("b", {
              children: "S\xE9curis\xE9e"
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: {
            span: 2
          },
          md: {
            span: 2
          },
          sm: 4,
          xs: 4,
          className: "ant-menu-horizontal",
          children: /*#__PURE__*/_jsxs(Space, {
            align: "end",
            direction: "horizontal",
            children: [/*#__PURE__*/_jsx(Speedometer, {
              size: 22
            }), /*#__PURE__*/_jsx("b", {
              children: "Efficace"
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: {
            span: 2
          },
          md: {
            span: 2
          },
          sm: 4,
          xs: 4,
          className: "ant-menu-horizontal",
          children: /*#__PURE__*/_jsxs(Space, {
            align: "end",
            direction: "horizontal",
            children: [/*#__PURE__*/_jsx(CupFill, {
              size: 22
            }), /*#__PURE__*/_jsx("b", {
              children: "Intuitive"
            })]
          })
        })]
      })
    })
  });
};

export default DefaultNav;